import { useCallback, useEffect, useState } from 'react';
import DataBreachService from '../../../../services/DataBreach.service';
import useNotify from '../../../../context/Notification/useNotify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function useManual(action) {
    const { t } = useTranslation();
    const notify = useNotify();
    const navigate = useNavigate();
    const [userOptions, setUserOptions] = useState([]);

    const getUser = useCallback(async () => {
        try {
            const { data } = await DataBreachService.getUserList();
            if (data?.resultData) {
                setUserOptions(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    const manualSubmit = useCallback(
        async (payload) => {
            try {
                const { data } = await DataBreachService.manualSubmit(payload);
                if (data?.resultData) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully saved data'),
                        timeOut: 1800,
                    });
                    action();
                    setTimeout(() => {
                        navigate(
                            `/data-breach/log/form/${data?.resultData.tDataBreachId}`
                        );
                    }, 1000);
                }
            } catch (error) {
                console.log(error);
            }
        },
        [action, navigate, notify, t]
    );

    useEffect(() => {
        getUser();
    }, [getUser]);

    return {
        userOptions,
        manualSubmit,
    };
}
